export const actions = {
    async obtener_sucursales({ commit, dispatch, state }, data) {
        let f = {
            api: `sucursales?filters[empresa][$eq]=${state.id_empresa_seleccionada}`
        }

        let r = await dispatch("obtener_data", f)
        commit('set_sucursales', r)

    },

}